export const MENU_TIMES = {
  Breakfast: { from: 600, to: 1130 },
  Brunch: { from: 900, to: 1630 },
  Lunch: { from: 1130, to: 1630 },
  Dinner: { from: 1630, to: 2400 }
};
